import React, { useEffect, useState } from 'react';
import { compose, graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { selectWScoreWheelActive } from 'containers/WScoreWheelPopup/selectors';
import { selectTourActive } from 'components/IntroTour/selectors';
import { selectOnboardActive } from 'components/OnboardTour/selectors';
import { makeDate } from 'utils/dates';
import { getUserData } from 'utils/graphQLFunctions';
import { MODIFY_USER_INVENTORY, USER_INVENTORY_BY_KEY_QUERY } from './queries';
import Games from './resources/Games.png';
import NewAvatars from './resources/NewAvatars.png';
import NewLook from './resources/NewLook.png';
import Sapphires from './resources/Sapphires.png';
import StandardPricing from './resources/StandardPricing.png';
import whatsNewLogo from './resources/WhatsNew.png';
import './WhatsNewModal.scss';

const inventoryKeyForWebLaunchAck = 'web_tutorial_cvWebLaunchAcknowledged';

function WhatsNewModal(props) {
  const [showWhatsNewInfo, setShowWhatsNewInfo] = useState(false);

  const whatsNewFeatures = [
    {
      featureName: 'newLook',
      imageSrc: NewLook,
      title: 'A Fresh, New Look',
      subTitle: `We've upgraded our style, made it simpler to use and expanded features on mobile devices.`
    },
    {
      featureName: 'newAvatars',
      imageSrc: NewAvatars,
      title: 'New Avatars',
      subTitle: `New faces at Wind Creek!  Fun choices with more to come.  Pick yours today.`
    },
    {
      featureName: 'standardPricing',
      imageSrc: StandardPricing,
      title: 'Standard Pricing',
      subTitle: `Say goodbye to moving prices!  WStore prices are now the same for everyone.`
    },
    {
      featureName: 'sapphires',
      imageSrc: Sapphires,
      title: 'Sapphires',
      subTitle: `A new way to earn and redeem your favorite Wind Creek Rewards like FREE Play.`
    },
    {
      featureName: 'games',
      imageSrc: Games,
      title: '40+ New Games',
      subTitle: `Come enjoy a ton of new games previously exclusive to Casinoverse.`
    }
  ];

  useEffect(() => {
    if (
      !props.tourActive &&
      !props.onboardActive &&
      !props.wscoreWheelActive &&
      props.inventoryData &&
      typeof props.inventoryData.userInventoryItemBalance !== 'undefined' &&
      props.inventoryData.userInventoryItemBalance <= 0
    ) {
      if (props.userData.user && props.userData.user.creationDate) {
        const creationDateStr = props.userData.user.creationDate;
        const creationDate = makeDate(creationDateStr);

        const launchDate = makeDate(process.env.REACT_APP_CV_WEB_LAUNCH_DATE);

        if (creationDate <= launchDate) {
          setShowWhatsNewInfo(true);
        } else {
          setShowWhatsNewInfo(false);
        }
      }
    } else {
      setShowWhatsNewInfo(false);
    }
  }, [
    props.userData,
    props.tourActive,
    props.onboardActive,
    props.wscoreWheelActive,
    props.inventoryData
  ]);

  const updateStatus = async () => {
    try {
      await props.modifyUserInventory({
        variables: {
          addItems: [{ key: inventoryKeyForWebLaunchAck, amount: 1 }],
          removeItems: []
        },
        update: (cache, { data }) => {
          if (
            data &&
            data.modifyUserInventory &&
            data.modifyUserInventory.updatedBalances &&
            data.modifyUserInventory.updatedBalances[0].amount
          ) {
            setShowWhatsNewInfo(false);

            cache.writeQuery({
              query: USER_INVENTORY_BY_KEY_QUERY,
              variables: { key: inventoryKeyForWebLaunchAck },
              data: {
                userInventoryItemBalance:
                  data.modifyUserInventory.updatedBalances[0].amount
              }
            });
          }
        }
      });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <React.Fragment>
      {showWhatsNewInfo && (
        <div className="whatsnew-popup-viewport">
          <div className="whatsnew-popup">
            <div className="whatsnew-popup-content">
              <header>
                <img src={whatsNewLogo} alt="What's New" />
              </header>
              {whatsNewFeatures &&
                whatsNewFeatures.map((item, index) => {
                  return (
                    <div
                      className="whatsnew-feature-lists"
                      key={`${item.featureName}-${index}`}
                    >
                      <div className="feature-list">
                        <img src={item.imageSrc} alt={item.featureName} />
                      </div>
                      <div className="feature-list">
                        <h2>{item.title}</h2>
                        <h6>{item.subTitle}</h6>
                      </div>
                    </div>
                  );
                })}
              <Link
                onClick={() => {
                  updateStatus();
                }}
                className="btn btn-success lets-play-btn"
                to={'/'}
              >
                Let's Play
              </Link>
              <Link
                className="learn-more-whatsnew"
                to={'/whats-new'}
                onClick={() => {
                  updateStatus();
                }}
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

const mapStateToProps = createStructuredSelector({
  tourActive: selectTourActive(),
  onboardActive: selectOnboardActive(),
  wscoreWheelActive: selectWScoreWheelActive()
});

const withConnect = connect(mapStateToProps);

const withUserInventoryItemBalance = graphql(USER_INVENTORY_BY_KEY_QUERY, {
  options: () => ({
    variables: { key: inventoryKeyForWebLaunchAck }
  }),
  name: 'inventoryData'
});

export default compose(
  getUserData({
    name: 'userData'
  }),
  graphql(MODIFY_USER_INVENTORY, { name: 'modifyUserInventory' }),
  withUserInventoryItemBalance,
  withConnect
)(WhatsNewModal);
